<i18n>
{
	"en": {
		"title": "Package Types",
		"couldNotFindAny": "Could not find package types"
	},
	"no": {
		"title": "Pakketype",
		"couldNotFindAny": "Fant ikke pakketype"
	}
}
</i18n>

<template>
	<div>
		<t-advanced-combo-box
			:title="title"
			:items="filteredItems"
			:selectedItem="selectedItem"
			:disabled="disabled || hasNoPackageTypes"
			displayKey="packageCode"
			:showCount="false"
			@change="onChange($event)"
			@input="onInput($event)"
			@select="$emit('select', $event)"
		>
			<template v-slot:optionItemContent="slotProps">
				<div class="item">
					<div class="item-main-text">{{ slotProps.item.packageName ? slotProps.item.packageName.no : '' }}</div>
					<div class="item-sub-text">{{ slotProps.item.packageCode }}</div>
				</div>
			</template>
		</t-advanced-combo-box>
	</div>
</template>

<script>
import { mapState, mapActions } from './store/packageTypes.store';

export default {
	name: 'PackageTypesFormInput',
	props: {
		value: String,
		disabled: {
			type: Boolean,
			default: false
		},
		noTitle: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			searchValue: '',
		};
	},
	computed: {
		...mapState(['packageTypes']),
		hasNoPackageTypes() {
			return !this.packageTypes || this.packageTypes.length === 0;
		},
		title() {
			return this.noTitle ? undefined : this.$t('title');
		},
		filteredItems() {
			let filteredItems = this.searchValue.length ?
				this.packageTypes.filter(
					packageType => (packageType.packageCode && packageType.packageCode.toLowerCase().includes(this.searchValue.toLowerCase()))
						|| (packageType.packageName && packageType.packageName.no && packageType.packageName.no.toLowerCase().includes(this.searchValue.toLowerCase()))
				) :
				this.packageTypes;

			return filteredItems;
		},
		selectedItem() {
			return this.value ? this.packageTypes.find(x => x.packageCode.toLowerCase() === this.value.toLowerCase() ) : undefined;
		}
	},
	async created() {
		await this.getPackageTypes();
	},
	methods: {
		...mapActions(['getPackageTypes']),
		onInput(value) {
			this.searchValue = value;
		},
		onChange(value) {
			let packageType = this.packageTypes.find( packageType => packageType.packageCode.toLowerCase() === value.toLowerCase() );

			if (packageType || value === '') {
				this.$emit('select', packageType);
			} else {
				this.$notify({
					type: 'error',
					title: this.$t('couldNotFindAny')
				});
			}
		},
	}
};
</script>

<style lang="scss" scoped>
.item-main-text {
	height:16px;
	line-height: 16px;
	font-weight: 600;
	overflow: hidden;
	white-space: nowrap;
}

.item-sub-text {
	height:16px;
	font-size: 10px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.6;
	letter-spacing: normal;
	overflow: hidden;
	white-space: nowrap;
}
</style>
